import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  deleteToken,
  onMessage,
} from "firebase/messaging";
import { ElNotification } from "element-plus";
import { usersAPI } from "@/shared/services/users.service";
import isWebview from "is-ua-webview";

export let app = null;
export let messaging = null;

if (!isWebview(window.navigator.userAgent)) {
  const firebaseConfig = {
    apiKey: "AIzaSyCLHLFK_b-8lXVnqdUke_sFq-ILZ9UVIWw",
    authDomain: "tippie-156e1.firebaseapp.com",
    projectId: "tippie-156e1",
    storageBucket: "tippie-156e1.appspot.com",
    messagingSenderId: "180107421673",
    appId: "1:180107421673:web:9beec5054155d6ecdb8d78",
  };

  app = initializeApp(firebaseConfig);
  messaging = getMessaging(app);

  if (navigator.serviceWorker && window.PushManager && window.Notification) {
    onMessage(messaging, (payload) => {
      ElNotification({
        title: payload.notification.title,
        message: payload.notification.body,
        type: "success",
        duration: 1000 * 3600,
      });
    });
  }
}

// Request Permission of Notifications
export async function requestPermission() {
  if (!("Notification" in window)) {
    sendLog({ 
      event: "push_permission_unsupported", 
      env: process.env.NODE_ENV,
      url: window.location.href,
    });
    console.warn("Browser does not support notifications.");
    return;
  }

  try {
    const permission = await Notification.requestPermission();
   
    const logBase = {
      env: process.env.NODE_ENV,
      url: window.location.href,
      timestamp: new Date().toISOString(),
      permission: permission
    };

    switch (permission) {
      case "granted":
        window.localStorage.setItem("push-msg-granted", "true");
        await sendLog({ ...logBase, event: "push_permission_granted" });
        
        await getFCMToken();
        break;

      case "denied":
        console.warn("User denied the permission for notifications.");
        window.localStorage.setItem("push-msg-granted", "false");
        await sendLog({ ...logBase, event: "push_permission_denied" });
        break;

      case "default":
        console.info("User dismissed the prompt.");
        await sendLog({ ...logBase, event: "push_permission_dismissed" });
        break;
    }

    return permission;
  } catch (err) {
    await sendLog({ 
      event: "push_permission_error", 
      error: err.message,
      env: process.env.NODE_ENV 
    });
    console.error("Error while requesting permission:", err);
  }
}


async function sendLog(payload) {
  try {
    await fetch(process.env.VUE_APP_LOGGER_URL, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  } catch (e) {
    console.error("Failed to send log to server", e);
  }
}

export async function deleteFCMToken(msg) {
  await deleteToken(msg);
}

async function getFCMToken() {
  await getToken(messaging, {
    vapidKey: process.env.VUE_APP_FIREBASE_PUBLIC_VAPID,
  })
    .then((currentToken) => {
      if (currentToken) {
        window.localStorage.setItem("push-msg-token", currentToken);
        usersAPI.addDeviceToken({
          device: "Web",
          deviceToken: currentToken,
        });
      } else {
        console.log(
          "No registration token available. Request permission to generate one.",
        );
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
    });
}
